module.exports = __webpack_public_path__ + "assets/pouting_face.a79195ee2b5baacba788634b0ca15589c18b3b83a5ccaf2dc3c2d0b240418756.png";